import request from '@/utils/request'
const apiPath = '/cust/customerCertificates'
const custApi = {
  /**
   * 新增修改【客户证件】
   */
  create(data) {
    return request.post(`${apiPath}/saveorupdate`, data)
  },
  /**
   * 分页查询【客户证件】
   */
  fetchList(query) {
    return request.get(`${apiPath}/listNew`, { params: query })
  },
  /**
   * 同意【客户证件】
   */
  agreeApply(query) {
    return request.get(`${apiPath}/AgreeCustomerCertificates`,{ params: query })
  },
  /**
   * 驳回【客户证件】
   */
  rejectApply(query) {
    return request.get(`${apiPath}/RejectCustomerCertificates`,{ params: query })
  },
  /**
   * 选项列表【用户标签分组】
   */
  options(){
     return request.get(`${apiPath}/options`)
  },
  fetchById(id){
    return request.get(`${apiPath}/${id}`)
  }
}
export default custApi
